import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-4 mt-3 ag-title" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = { class: "font-weight-bolder" }
const _hoisted_4 = {
  key: 1,
  class: "mr-1 ml-1 ag-icon ag-icon_rightArrow mt-1"
}
const _hoisted_5 = { class: "font-weight-bolder" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 3,
  class: "font-weight-bolder"
}
const _hoisted_9 = {
  key: 4,
  class: "d-flex align-items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "mr-1 ml-1 ag-icon ag-icon_rightArrow mt-1" }, null, -1)
const _hoisted_11 = { class: "font-weight-bolder" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "ag-icon ag-icon_smallclose ml-1 mt-1" }, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_15 = { class: "font-weight-bolder" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "mr-1 ml-1 ag-icon ag-icon_rightArrow mt-1" }, null, -1)
const _hoisted_17 = { class: "font-weight-bolder" }
const _hoisted_18 = {
  key: 1,
  class: "font-weight-bolder"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_role = _resolveDirective("role")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$route.matched[_ctx.$route.matched.length - 1].children.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.$route.matched[_ctx.$route.matched.length - 1].meta.default)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: _ctx.$route.matched[_ctx.$route.matched.length - 1].meta.default.path
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.t(_ctx.$route.matched[_ctx.$route.matched.length - 1].meta.default.title)), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.$route.matched[_ctx.$route.matched.length - 1].meta.default)
            ? (_openBlock(), _createElementBlock("i", _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.$route.matched[_ctx.$route.matched.length - 1].meta.breadcrumb)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: _ctx.$route.matched[_ctx.$route.matched.length - 1].meta.breadcrumb
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h5", _hoisted_5, [
                    (_ctx.$route.matched[1].meta.title === 'dashboard')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _withDirectives((_openBlock(), _createElementBlock("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.t("agmsCompanyOverview")), 1)
                          ])), [
                            [_directive_role, [_ctx.Roles.AGMSAdmin]]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.t("partnerOverview")), 1)
                          ])), [
                            [_directive_role, [_ctx.Roles.PartnerAdmin]]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.t("companyOverview")), 1)
                          ])), [
                            [_directive_role, [_ctx.Roles.CompanyAdmin]]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.t("siteCompanyOverview")), 1)
                          ])), [
                            [_directive_role, [_ctx.Roles.SiteAdmin, _ctx.Roles.SiteAudit]]
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.t("groupCompanyOverview")), 1)
                          ])), [
                            [_directive_role, [_ctx.Roles.GroupAdmin, _ctx.Roles.GroupAudit]]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.t(_ctx.$route.matched[1].meta.title)), 1))
                  ])
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_8, _toDisplayString(_ctx.t(_ctx.$route.matched[_ctx.$route.matched.length - 1].meta.title)), 1)),
          (
          _ctx.$route.matched[_ctx.$route.matched.length - 1].meta.breadcrumb &&
          _ctx.$route.href.split('/')[2] !==
            (_ctx.$route.matched[_ctx.$route.matched.length - 1].meta.breadcrumb.split(
              '/'
            ).length === 1
              ? _ctx.$route.matched[_ctx.$route.matched.length - 1].meta.breadcrumb
              : _ctx.$route.matched[_ctx.$route.matched.length - 1].meta.breadcrumb.split(
                  '/'
                )[_ctx.$route.href.split('/').length - 1])
        )
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.t(_ctx.$route.meta.title)), 1),
                _createVNode(_component_router_link, {
                  to: _ctx.$route.matched[_ctx.$route.matched.length - 1].meta.breadcrumb
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_ctx.$route.matched[_ctx.$route.matched.length - 1].meta.breadcrumbs)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$route.matched[_ctx.$route.matched.length - 1].meta
            .breadcrumbs, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "d-flex align-items-center"
                  }, [
                    _createVNode(_component_router_link, {
                      to: item.route
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.t(item.title)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _hoisted_16
                  ]))
                }), 128)),
                _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.t(_ctx.$route.meta.title)) + "2", 1)
              ]))
            : (_openBlock(), _createElementBlock("h5", _hoisted_18, [
                (
            _ctx.$route.matched[1].meta.title === 'dashboard' &&
            _ctx.$route.fullPath != '/dashboard/custom-dashboard'
          )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.t("agmsCompanyOverview")), 1)
                      ])), [
                        [_directive_role, [_ctx.Roles.AGMSAdmin]]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.t("partnerOverview")), 1)
                      ])), [
                        [_directive_role, [_ctx.Roles.PartnerAdmin]]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.t("companyOverview")), 1)
                      ])), [
                        [_directive_role, [_ctx.Roles.CompanyAdmin]]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.t("siteCompanyOverview")), 1)
                      ])), [
                        [_directive_role, [_ctx.Roles.SiteAdmin, _ctx.Roles.SiteAudit]]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.t("groupCompanyOverview")), 1)
                      ])), [
                        [_directive_role, [_ctx.Roles.GroupAdmin, _ctx.Roles.GroupAudit]]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.t(_ctx.$route.meta.title)), 1))
              ]))
        ]))
  ]))
}